enum GlobalSearchSectionKey {
  RECENT = "recent",
  RECORDS = "records",
  SAVED_LOCATIONS = "savedLocations",
  SET_MODE = "setMode",
}

export default GlobalSearchSectionKey;
